















































































import Vue, { PropType } from "vue"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"
import { JobCategoryOption } from "~/clStores/profileSearchParameterOption"
import BooleanCheckboxField from "~/components/guideline/form/field/BooleanCheckboxField.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"
import { StandardApplicationError } from "~/errorHandlers"

interface DataType {
  expandedLargeCategoryIds: number[]
}

export default Vue.extend({
  components: {
    BooleanCheckboxField,
    MaterialIcon,
    FilterDescription,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
    numberOfHits: {
      type: Number,
      default: null,
    },
    options: {
      type: Array as PropType<JobCategoryOption[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      expandedLargeCategoryIds: [],
    }
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
  },
  methods: {
    isSelectedLargeCategory(id: number): boolean {
      // すべての小カテが選択されていること
      return this.getSmallJobCategoryOptions(id).every((s) =>
        this.isSelectedSmallCategory(s.value)
      )
    },
    isSelectedSmallCategory(id: number): boolean {
      return this.value.includes(id)
    },
    isExpanded(largeCategoryId: number): boolean {
      return this.expandedLargeCategoryIds.includes(largeCategoryId)
    },
    toggleExpandedStatus(largeCategoryId: number) {
      if (this.isExpanded(largeCategoryId)) {
        this.expandedLargeCategoryIds = this.expandedLargeCategoryIds.filter(
          (id) => id !== largeCategoryId
        )
      } else {
        this.expandedLargeCategoryIds = [
          ...this.expandedLargeCategoryIds,
          largeCategoryId,
        ]
      }
    },
    getSmallJobCategoryOptions(largeCategoryId: number) {
      const target = this.options.find((o) => o.value === largeCategoryId)

      if (!target) {
        throw new StandardApplicationError("該当する大カテが存在しません")
      }

      return target.smallJobCategories
    },
    handleSelected(selectedSmallCategoryIds: number[]) {
      this.$emit("input", selectedSmallCategoryIds)
    },
    selectLargeJobCategory(selectedId: number) {
      const selectedSmallJobCategoryIds = this.getSmallJobCategoryOptions(
        selectedId
      ).map((s) => s.value)

      this.handleSelected(
        this.isSelectedLargeCategory(selectedId)
          ? // 選択を解除
            this.value.filter((id) => !selectedSmallJobCategoryIds.includes(id))
          : // 選択
            [...this.value, ...selectedSmallJobCategoryIds]
      )
    },
    selectSmallJobCategory(selectedId: number) {
      this.handleSelected(
        this.isSelectedSmallCategory(selectedId)
          ? // 選択を解除
            this.value.filter((id) => id !== selectedId)
          : // 選択
            [...this.value, selectedId]
      )
    },
  },
})
